import type { ReactNode } from 'react'

import { MUIThemeProvider } from './MUIThemeProvider'

// TODO: Add theme prop
export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  return <MUIThemeProvider>{children}</MUIThemeProvider>
}
